import React, { PureComponent, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import CountryContext from '../../../../common/context/country';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Grid, Cell, Section } from 'formlabs-web-components/Grid';
import { Header } from 'formlabs-web-components/Type';
import { Link } from 'formlabs-web-components/Link';
import { Video } from 'formlabs-web-components/Media';

import { withTranslation, Trans } from 'react-i18next';

import posterNotFound from '../../../../../public/404.jpg';

const NotFound = DisplayComponent(
  class App extends PureComponent {
    static contextType = CountryContext;
    render() {
      const { t } = this.props;
      const { path } = this.context;

      return (
        <Fragment>
          <Helmet>
            <title>{t('Page Not Found')}</title>
          </Helmet>
          <Section hasContainer={true} marginBefore="4rem">
            <Grid
              direction="x"
              gutters="margin"
              primaryAlignment="align-center"
              secondaryAlignment="align-middle"
            >
              <Cell mediumSize={10} mediumOrder={2}>
                <Video
                  src="https://formlabs-media.formlabs.com/filer_public/8d/d8/8dd8471f-d78c-41bd-b73f-9e39b08be580/404.mp4"
                  videoThumb={posterNotFound}
                  autoPlay={true}
                  loop={false}
                />
              </Cell>
              <Cell
                mediumSize={10}
                mediumOrder={1}
                secondaryAlignment="align-self-bottom"
              >
                <div style={{ marginBottom: '8rem' }}>
                  <Header level={2} displayAs={3}>
                    {t('Sorry, that page cannot be found')}
                  </Header>
                  <Trans>
                    <p>
                      You might want to start over at the{' '}
                      <Link to={path}>Formlabs home page</Link> to find what you
                      are looking for.
                    </p>
                  </Trans>
                </div>
              </Cell>
            </Grid>
          </Section>
          <Section marginBefore="4rem" />
        </Fragment>
      );
    }
  }
);

export default withTranslation()(NotFound);
